import React from 'react';
import PropTypes from 'prop-types';

import { Image } from 'components/core/Image';
import { Container } from 'components/core/Page';
import { H2 } from 'components/core/Typography';

import fewSimpleSteps from 'assets/images/landing/homepage/few-simple-steps.svg';
import swerveSimpleStep from 'assets/images/layout/swerve-simple-step.svg';

import MarketingStepCard from '../MarketingStepCard/MarketingStepCard';

import './MarketingSimpleSteps.scss';

export function MarketingSimpleSteps({ stepsCards }) {
	return (
		<section className="simple-steps-section">
			<Container className="simple-steps-container">
				<div className="simple-steps-title">
					<Image
						src={fewSimpleSteps}
						alt="simple steps icon"
					/>
					<H2
						size="mediumLarge"
						weight="extraBold"
						color="black"
						last
					>
						Make a Free Storage Reservation in a Few Simple Steps
					</H2>
				</div>
				<div className="simple-steps-card-arrangement">
					{stepsCards.map((stepCard) => (
						<MarketingStepCard
							key={stepCard.title}
							stepCard={stepCard}
						/>
					))}
				</div>
			</Container>
			<Image
				src={swerveSimpleStep}
				className="wave-image"
			/>
		</section>
	);
}

MarketingSimpleSteps.propTypes = {
	stepsCards: PropTypes.arrayOf(
		PropTypes.shape({
			imageSrc: PropTypes.string,
			step: PropTypes.string,
			title: PropTypes.string,
			description: PropTypes.string,
		}),
	),
};

export default MarketingSimpleSteps;
